import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SharedModule } from '../shared/shared.module';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { FeedbackToastComponent } from '../shared/components/feedback-toast/feedback-toast.component';
import { OverlayOutletComponent } from '../shared/components/overlay-outlet/overlay-outlet.component';

@NgModule({
    declarations: [LayoutComponent, SidebarComponent, BreadcrumbsComponent],
    imports: [CommonModule, SharedModule, FeedbackToastComponent, OverlayOutletComponent],
    exports: [LayoutComponent, SidebarComponent]
})
export class LayoutModule {}
